<template>
  <div class="task-member-box" v-loading="loading">
    <basiCcontainer>
      <template #head>
        <div class="c-top-nav">
          <div class="member-title">项目成员</div>
          <wf-button icon="icon iconfont iconicon_enlarge" v-if="isBoss || isAdmin" @click="add">添加成员</wf-button>
        </div>
      </template>
      <div class="project-wrap" v-if="dataset.length> 0">
        <div class="project-member" v-for="(item) in dataset" :key="item.name">
          <div class="depart-name">
            <!-- <span class="line" :style="{'background':Color()}"></span> -->
            {{ item.name }}
          </div>
          <div class="member-item" v-for="innerItem in item.data" :key="innerItem.uid" @click="memeberSetting(innerItem)">
            <div class="member-avatar">
              <wf-button text>
                <MyAvatar :userName="innerItem.realname" :imgUrl="innerItem.user_avatar" width="28px" height="28px">{{innerItem.realname}}</MyAvatar>
                <div v-if="[1, 2].includes(innerItem.type)" class="member-type" :class="innerItem.type == 1 ? 'crate-member' : innerItem.type == 2 ? 'manage-member' :''">{{innerItem.type | memberTypeTxt}}</div>
              </wf-button>
            </div>
          </div>
        </div>
      </div>
      <nothing @button-click="add" :config="{type:'img_add_task',tip:'暂无团队成员，快去添加小伙伴',btnText:isBoss || isAdmin ? '添加成员' : ''}" v-else-if="!loading"></nothing>
    </basiCcontainer>
    <!-- 抽屉 -->
    <el-drawer :visible.sync="visibleShow" :wrapperClosable="false" title="成员设置">
      <template #title>
        <div class="auto-title-style">
          <MyAvatar :userName="currentMember.realname" :imgUrl="currentMember.user_avatar" width="28px" height="28px">
            <span class="auto-title-style---text">{{currentMember.realname}}</span>
          </MyAvatar>
          <span class="auto-title-style---text">的成员设置</span>
        </div>
      </template>
      <MemberSetting v-if="visibleShow" @success="success" @cancel="cancel" :memberInfo="currentMember" :projectId="projectId - 0"></MemberSetting>
    </el-drawer>
    <el-dialog title="添加成员" :visible.sync="visibleAdd" width="auto"  v-if="visibleAdd">
      <ParticipantList @close="visibleAdd = false" v-model="memberValue" @confirm="slecetVaule" :taskMemberlist="options" :lockUid="lockUid"></ParticipantList>
    </el-dialog>
  </div>
</template>

<script>
import MyAvatar from '@/components/avatar'
import { Cookie } from '@/utils/utils';
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex';
import MemberSetting from "./memberSetting";
import api from '@/services/api/task/task'
import bus from '@/bus'
import ParticipantList from '@/views/customKeyPage/components/participant/participantList'
function createdCascaderData(sourceData) {
  return sourceData.map(item => {
    let temp = {};
    temp["uid"] = item.uid || item.depart_id;
    temp["realname"] = item.name || item.realname;
    if (item.member && item.member.length > 0) {
      temp["children"] = createdCascaderData(item.member);
    } else {
      temp["children"] = null;
    }
    return temp;
  });
}

// 平铺数据
function tileData(dataList) {
  let arr = [];
  dataList.forEach(item => {
    arr = [...arr, ...item.member];
  });
  return arr;
}

const memberTypeMap = {
  1: "创建人",
  2: "管理员"
}
export default {
  name: "member",
  components: {
    MemberSetting,
    MyAvatar,
    ParticipantList
  },
  data() {
    return {
      projectId: null,
      projectName: null,
      memberValue: [],
      memberList: [],
      visibleAdd: false,
      isFoucs: false,
      defaultArr: [],
      options: [],
      addMemberList: [],
      oldMemeberList: [],
      visibleShow: false,
      currentMember: {},
      loading: false,
      dataset: [],
      lockUid: []
    };
  },
  async created() {
    this.projectName = this.$route.query.projectName;
    this.projectId = this.$route.query.projectId;
    let { fullPath, path, query, name } = this.$route
    this.SET_MENUTXT({ fullPath, path, query, name, title: this.$route.meta.title, txt: this.$route.meta.title })
    this.init()
    bus.$on('addProjectMember', () => {
      this.add()
    })
  },
  beforeRouteLave(to, from, next) {
    this.SET_MENUTXT('')
    next()
  },
  computed: {
    ...mapGetters("layout/layout", ['userInfo']),
    adminMemberList() {
      return this.oldMemeberList.filter(item => {
        return [1, 2].includes(item.type)
      }).map((item) => {
        return item.uid
      })
    },
    isOnlyAdmin() {
      return this.oldMemeberList.filter(item => {
        return [2].includes(item.type)
      }).map((item) => {
        return item.uid
      })
    },
  },
  filters: {
    memberTypeTxt(val) {
      return memberTypeMap[val] || ''
    }
  },
  methods: {
    ...mapActions('project/project', ['updateProjectMember', 'getNewProjectMember']),
    ...mapActions('department/department', ['getDepartmentUser']),
    ...mapMutations('layout/layout', ['SET_MENUTXT']),
    ...mapMutations('project/project', ['SET_PROJECTMEMBER']),
    async init() {
      this.loading = true
      await this.getProjectMembers()
      await this.fetchDepartmentUser();
      this.loading = false
    },
    getProjectMembers() {
      return api.getProjectMembers({ project_id: this.projectId, working_status: '在职' }).then(res => {
        this.dataset = []
        this.oldMemeberList = []
        res.forEach(res => {
          for (let key in res) {
            this.oldMemeberList.push(...res[key])
            this.dataset.push({
              name: key,
              data: res[key],
            })
          }
        })
      })
    },
    fetchDepartmentUser() {
      this.lockUid = []
      this.memberValue = []
      return this.getDepartmentUser({ working_status: '在职' }).then(res => {
        this.options = createdCascaderData(res.departmentgroup);
        this.lockUid = this.oldMemeberList.map(res => res.uid)
        this.options.find((res) => {
          if(res.children){
            res.children.find(res => {
              if (this.lockUid && this.lockUid.indexOf(res.uid) > -1) {
                this.memberValue.push(res)
                res.disabled = true
              } else {
                res.disabled = false
              }
            })
          }
        })
      });
    },
    Color() {
      this.r = Math.floor(Math.random() * 255);
      this.g = Math.floor(Math.random() * 255);
      this.b = Math.floor(Math.random() * 255);
      return 'rgba(' + this.r + ',' + this.g + ',' + this.b + ',1)';
    },
    add() {
      this.visibleAdd = true;
    },
    selectChange(v1, v2) {
      // 这里更新用户列表
      let checkedNode = this.$refs["sle"].getCheckedNodes(true);
      this.addMemberList = checkedNode.map(item => {
        return {
          uid: item.value,
          realname: item.label
        };
      });
    },
    onSubmit() {
      let memberArr = this.defaultArr.map((item) => {
        return this.findOldMemberInfo(item)
      })
      this.updateProjectMember({
        project_id: this.projectId,
        member: memberArr
      }).then(res => {
        this.init();
        this.visibleAdd = false;
        this.defaultArr = [];
        this.addMemberList = [];
        this.SET_PROJECTMEMBER('')
      }).catch(() => {
        this.visibleAdd = false;
      })
    },
    findOldMemberInfo(uid) {
      let result = {
        uid: uid,
        type: 0
      }
      let search = this.oldMemeberList.filter((item) => {
        if (item.uid === uid) {
          return item
        }
      })
      if (search.length > 0) {
        result.type = search[0].type
      }
      return result;
    },
    memeberSetting(memberData) {
      // 检查当前登录用户是否项目管理员
      if (!this.adminMemberList.includes(this.userInfo.uid) && !this.isBoss) {
        return
      }
      if (memberData.type === 2 && this.isOnlyAdmin.includes(this.userInfo.uid)) { // 管理员不能编辑管理员
        return
      }
      if (memberData.type === 1) { //创建人不能编辑
        return
      }
      this.currentMember = memberData;
      this.visibleShow = true;
    },
    success() {
      this.init()
      this.visibleShow = false
      this.SET_PROJECTMEMBER('')
    },
    cancel() {
      this.visibleShow = false
    },
    slecetVaule(data) {
      this.visibleAdd = false
      this.defaultArr = data && data.length > 0 ? data.map(res => res.uid) : []
      this.onSubmit()
      console.log(data)
    }
  }
};
</script>
<style lang="scss">
.task-member-box {
  position: relative;
  height: 100%;
  .my-form {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
  }
  .member-avatar-dialog {
    padding: 0 8px;
    height: 32px;
  }
  .auto-title-style {
    font-weight: normal;
    display: flex;
    align-items: center;
    font-size: 16px;
    .auto-title-style---text {
      margin-right: 20px;
    }
  }
  .search-box {
    border: 0 none;
  }
  .project-seiing {
    &:hover {
      color: #999 !important;
    }
    font-weight: bold;
  }
  .c-top-nav {
    height: 48px;
    line-height: 48px;
    padding: 0 23px;
    box-sizing: border-box;
    .member-title {
      font-size: 20px;
    }
  }
  .project-member {
    padding: 20px 0;
    display: flex;
    flex-wrap: wrap;
    padding-left: 23px;
    flex: 1;
    align-content: flex-start;
    border-bottom: 1px solid rgba(231, 232, 237, 0.6);
  }
  .depart-name {
    width: 100%;
    text-align: left;
    font-size: 14px;
    margin-bottom: 20px;
    color: #0d1f3c;
    font-weight: bold;
    // opacity: 0.6;
    display: flex;
  }
  .line {
    width: 4px;
    height: 14px;
    border-radius: 4px;
    display: block;
    margin-right: 16px;
  }
  .member-item {
    font-size: 14px;
    cursor: pointer;
    height: 40px;
    background: #ffffff;
    /* box-shadow: 0 6px 10px 0 rgba(173,196,225,0.20) */
    box-shadow: none;
    border-radius: 4px;
  }
  .member-type {
    height: 12px;
    padding: 2px 5px;
    line-height: 12px;
    text-align: center;
    margin-left: 16px;
  }
  .crate-member {
    font-size: 12px;
    color: #ffa350;
    background: rgba(255, 163, 80, 0.16);
    border-radius: 2px;
    border-radius: 2px;
    margin-left: 8px;
  }
  .manage-member {
    font-size: 12px;
    color: #00b97e;
    background: rgba(0, 185, 126, 0.16);
    border-radius: 2px;
    border-radius: 2px;
    margin-left: 8px;
  }
  .project-wrap {
    flex: 1;
  }
}
</style>
